import styled, { keyframes } from "styled-components";
import { getTopValue, getNumberOfWords } from "./graphHelper";

type Props = {
  height: number;
  color: string;
  name: string;
};
type BarNameProps = {
  topValue: number;
  numberOfWords: number;
};
export const MakeBar = ({ height, color, name }: Props) => {
  return (
    <StyledBar height={height} color={color} name={name}>
      <TopCircle>
        <BarName
          numberOfWords={getNumberOfWords(name)}
          topValue={getTopValue(name)}
        >
          {name}
        </BarName>
      </TopCircle>
    </StyledBar>
  );
};

const progressBar = (y: number) => keyframes`
0% { height: 0; }
  ${y}% { height: ${y}px; }
`;

const StyledBar = styled.div<Props>`
  display: block;
  height: ${(props) => props.height}px;
  width: 60px;
  background: ${(props) => props.color};
  position: relative;
  border-radius: 30px 30px 2px 2px;
  animation: ${(props) => progressBar(props.height)} 3s ease-in-out;
  animation-fill-mode: forwards;
  @media only screen and (max-width: 768px) {
    width: 20px;
  }
`;

const TopCircle = styled.div`
  position: absolute;
  height: 32px;
  width: 32px;
  border-radius: 40px;
  border: 3px solid #f0f0f0;
  left: 50%;
  margin-left: -20px;
  top: -20px;
  background: #d2d8df;
  display: flex;
  justify-content: center;
  @media only screen and (max-width: 768px) {
    height: 12px;
    width: 12px;
    margin-left: -7px;
    top: -8px;
    border: 1px solid #f0f0f0;
  }
`;

const BarName = styled.div<BarNameProps>`
  position: absolute;
  top: ${(props) => "-" + props.topValue + "rem"};
  background-color: #14142b;
  border-radius: 5px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  font-family: "Poppins-Bold";
  padding: ${(props) =>
    props.numberOfWords === 1 ? "0.5625rem 2.5rem" : "0.625rem 1rem"};
  text-align: center;
  @media only screen and (max-width: 768px) {
    font-size: 8px;
    top: calc(${(props) => "-" + props.topValue + "rem"} + 1rem);
  }
`;
